import { Checkbox } from '@optimus-web/core';
import { DisplayBillState } from '@mews-commander/data-access';
import { useCityLedgerMultipleInvoicesContext } from '../../../context/CityLedgerMultipleInvoicesContext';
import { AccountsTableData } from '../../../types';
import { useCityLedgerSelectedDate } from '../../../context/CityLedgerFilterContext';

export const BulkAccountCheckbox = ({ data }: { data: AccountsTableData }) => {
    const { isPastDate } = useCityLedgerSelectedDate();
    const { selectedInvoices, setSelectedInvoices } = useCityLedgerMultipleInvoicesContext();

    const individualInvoice = data?.subRows || [];
    const invoices = individualInvoice
        .map((invoice) => ({
            invoiceId: invoice.invoiceId || '',
            ownerName: data.ownerName || '',
            ownerId: data.ownerId || '',
            invoiceNumber: invoice?.invoiceNumber || '',
            dueDateLocal: invoice?.dueDateLocal || '',
            balance: invoice?.balance || { value: 0, currency: 'EUR' },
            state: invoice?.state,
            ownerEmail: data.ownerEmail || '',
        }))
        .filter((invoice) => invoice.invoiceId !== undefined);

    const handleBulkAccountChange = (_event: React.SyntheticEvent<HTMLElement>, checked: boolean) => {
        setSelectedInvoices((prevSelectedInvoices) => {
            if (checked) {
                const newInvoices = invoices.filter(
                    (invoice) => invoice && !prevSelectedInvoices.some((item) => item.invoiceId === invoice.invoiceId)
                );

                return [...prevSelectedInvoices, ...newInvoices];
            }
            return prevSelectedInvoices.filter(
                (invoice) => !invoices.some((item) => item.invoiceId === invoice.invoiceId)
            );
        });
    };

    const isAllSelected = invoices.every((invoice) =>
        selectedInvoices.some((item) => item.invoiceId === invoice?.invoiceId)
    );

    const isSomeSelected = invoices.some((invoice) =>
        selectedInvoices.some((item) => item.invoiceId === invoice?.invoiceId)
    );

    const isSomeInvoicesProcessing = invoices.some((item) => item.state === DisplayBillState.ProcessingPayment);

    return (
        <Checkbox
            data-test-id="account-bulk-checkbox"
            checked={isAllSelected}
            indeterminate={isSomeSelected && !isAllSelected}
            onChange={handleBulkAccountChange}
            disabled={isPastDate || isSomeInvoicesProcessing}
        />
    );
};
